import { render } from "./CardAppLight.vue?vue&type=template&id=53b4f9a7&scoped=true"
import script from "./CardAppLight.vue?vue&type=script&lang=js"
export * from "./CardAppLight.vue?vue&type=script&lang=js"

import "./CardAppLight.vue?vue&type=style&index=0&id=53b4f9a7&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b4f9a7"]])

export default __exports__